<div class="layout-main">
  <div class="container-fluid">
    <div class="row" style="margin-bottom: -2%">
      <div class="pb-2 mb-3 col-6 col-lg-6 col-md-6">
        <h2>
          <b>Precision Time Exchange monitoring page</b>
        </h2>
      </div>
    </div>
    <hr>
    <p-tabView (onChange)="changeSelectedXco($event)" *ngIf="clientTimeSyncXcos.length > 0">
      <p-tabPanel *ngFor="let xco of clientTimeSyncXcos; let i = index" [header]="xco" [selected]="i == 0">
        <ng-container *ngIf="timeSyncData">
          <div class="section" *ngFor="let section of graphsSectionsArray | keyvalue: keepOriginalOrder">
            <div class="row">
              <div class="col-6">
                <h4 class="section-header">
                  {{section.key}}
                </h4>
              </div>
              <div class="col-6" *ngIf="section.key === 'Client Service Accuracy Statistics'">
                <button type="button" pButton icon="fa fa-refresh pr-2" iconPos="left" (click)="loadTimeSyncData()"
                        label="Refresh Data" style="float:right; margin-left: 10px"></button>
                <div [ngClass]="{ 'text-danger': isDataObsolete }" style="float:right; padding-top: 5px; font-weight: bolder">
                 Last refreshed data at {{ lastRefreshedDataAt }}
                </div>
              </div>
            </div>
            <div class="row col-12" *ngIf="currentRes && section.key === 'Client Service Accuracy Statistics'" [ngStyle]="{'opacity': isDataObsolete ? 0.5 : 1}"
                 [attr.title]="isDataObsolete ? 'This data is obsolete' : ''">
              <div class="col-6"><b>NIST Service Name</b> :  {{ currentRes['tmasService'] }}</div>
              <div class="col-6"><b>NIST Service Locking Status</b> :
                <b
                  [ngClass]="{'text-success': currentRes['lockingStatus'] === 0, 'text-danger': currentRes['lockingStatus'] === 2}">
                  {{ currentRes['lockingStatus'] | time_sync_status }}
                </b>
              </div>
              <div class="col-6"><b>NIST Service Locking Status Txt</b> :  {{ currentRes['lockingStatusText'] }}</div>
              <div class="col-6"><b>NIST Neighbor service</b> :  {{ currentRes['neighborService'] }}</div>
              <div class="col-6"><b>NIST Service Locking Status To Neighbor</b> :
                <b
                  [ngClass]="{'text-success': currentRes['neighborLockingStatus'] === 0, 'text-danger': currentRes['neighborLockingStatus'] === 2}">
                  {{ currentRes['neighborLockingStatus'] | time_sync_status }}
                </b>
              </div>
              <div class="col-6"><b>NIST Service Neighbor Locking Status</b> :
                <b
                  [ngClass]="{'text-success': currentRes['neighborStatus'] === 0, 'text-danger': currentRes['neighborStatus'] === 2}">
                  {{ currentRes['neighborStatus'] | time_sync_status }}
                </b>
              </div>
              <div class="col-6"><b>Client-Facing Device Time Source Status</b> :
                <b
                  [ngClass]="{'text-success': currentRes['clientStatus'] === 0, 'text-danger': currentRes['clientStatus'] === 2}">
                  {{ currentRes['clientStatus'] | time_sync_status }}
                </b>
              </div>
            </div>
            <div *ngIf="currentRes && section.key === 'Client SFP Port Stats'" class="col-6"  [ngStyle]="{'opacity': isDataObsolete ? 0.5 : 1}"
                 [attr.title]="isDataObsolete ? 'This data is obsolete' : ''"><b>Detection status</b> :
              <b [ngClass]="{'text-success': currentRes['detect'] === 1, 'text-danger': currentRes['detect'] === 0}">
                <ng-container *ngIf="currentRes['detect'] === 1">
                  OK
                </ng-container>
                <ng-container *ngIf="currentRes['detect'] === 0">
                  NOK
                </ng-container>
              </b>
            </div>
            <div *ngIf="currentRes && section.key === 'Client Link Statistics'" class="col-6" [ngStyle]="{'opacity': isDataObsolete ? 0.5 : 1}"
                 [attr.title]="isDataObsolete ? 'This data is obsolete' : ''"><b>Link status</b> :
              <b [ngClass]="{'text-success': currentRes['linkStatus'] === 0, 'text-danger': currentRes['linkStatus'] === 2}">
                {{ currentRes['linkStatus'] | time_sync_status}}
              </b>
            </div>
            <div class="row">
              <div *ngFor="let id of section.value" class="col-6">
                <p-toolbar class="mb-0 graph-toolbar">
                  <div class="row col-12 mb-0">
                    <div class="col-3 row">
                      <label class="col-4 mb-0 col-form-label"><b>Unit:</b></label>
                      <div class="col-8 mb-0 col-form-input">
                        <p-dropdown (onChange)="updateTimeScale(xco, id)"
                                    [(ngModel)]="selectedUnit[id]"
                                    [options]="graphHandlerService.zoomOptions"
                                    [showClear]="true"
                                    [style]="{'minWidth':'50px'}"
                                    placeholder="Choose a time unit">
                        </p-dropdown>
                      </div>
                    </div>
                    <div class="col-7 row">
                      <label class="col-2 col-form-label"><b>Layout</b></label>
                      <div class="col-10 mb-0 col-form-input">
                        <p-selectButton (onChange)="updateTimeScale(xco, id)"
                                        [(ngModel)]="selectedPeriod[id]"
                                        [options]="graphHandlerService.periods"></p-selectButton>
                      </div>
                    </div>
                    <div class="col-3">
                      <button (click)="resetCharZoom(xco, id)" class="ui-button-text"
                              label="Reset Zoom"
                              pButton></button>
                    </div>
                  </div>
                </p-toolbar>
                <div (click)="zoomOut(id)" *ngIf="isZoomedIn[id]" class="overlay"></div>
                <div [ngClass]="{'fullscreen-chart': isZoomedIn[id]}" class="m-2" style="border: 1px solid #EAE9E8">
                  <div class="row col-12" style="padding-right: 0">
                    <div class="col-12 mb-0" style="padding: 0">
                      <i (click)="zoomIn(id)" *ngIf="!isZoomedIn[id]" class="pi pi-window-maximize float-right cursor-pointer"
                         pTooltip="Zoom In"
                         style="background-color: white; color: #007bff; font-size: 13px; padding: 5px 0 0;"></i>
                      <i *ngIf="isZoomedIn[id]" (click)="zoomOut(id)" class="pi pi-times float-right cursor-pointer"
                         style="background-color: white; color: #007bff; font-size: 13px; padding: 0;"></i>
                    </div>
                  </div>
                  <p-chart #chart [data]="data[id][xco]"
                           [id]="id"
                           [options]="graphOptions"
                           class="mt-1"
                           type="line"></p-chart>
                </div>
              </div>
            </div>
          </div>
        </ng-container>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>
